import { createFileRoute } from '@tanstack/react-router';
import { ComingSoon } from '@/features/placeholder/ComingSoon.tsx';

// Placeholder until this area is ported — see docs/features/*-production.md.
export const Route = createFileRoute('/_app/production')({
  component: ProductionPage,
});

function ProductionPage() {
  return <ComingSoon slug="production" />;
}
